<!--
 * @Description  : 商品管理
 * @Author       : git config user.sname
 * @Date         : 2025-12-15 11:45:54
 * @LastEditors  : git config user.sname
 * @LastEditTime : 2025-12-15 13:34:43
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\commodity-management\home.vue
-->
<template>
	<transition name="fade"
				mode="out-in">
		<!-- 用做缓存页面 -->
		<keep-alive :include="cachedViews">
			<router-view :key="key" />
		</keep-alive>
	</transition>
</template>

<script>
import { mapState } from "vuex";

export default {
	name: 'commodity-management',
	data() {
		return {}
	},
	methods: {},
	computed: {
		...mapState('tags', {
			cachedViews: state => state.cacheTags
		}),
		key() {
			// console.log(this.$route.name)
			return this.$route.name
		}
	}
}
</script>

<style scoped lang="less">
</style>